import { Component, AfterViewInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-video-background',
  templateUrl: './video-background.component.html',
  styleUrls: ['./video-background.component.css']
})
export class VideoBackgroundComponent implements AfterViewInit {
  videoId: string = '-yLhDDGoYc4'; // Ganti dengan ID video YouTube yang diinginkan
  title: string = 'East Indonesia Trip';
  description: string = 'East Indonesia Trip is a professional trip planner based in Bali. have been covering numerous trips since 2015 and have been obtain high customer retention rate.';
  // videoUrl: SafeResourceUrl;

  videoPath: string = 'assets/video/web_east_x264.mp4';

  // constructor(private sanitizer: DomSanitizer) {
  //   this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.getVideoUrl());
  // }

  ngAfterViewInit(): void {
    // Tunggu hingga iframe dimuat, kemudian aktifkan kelas fade-in
    // const iframe = document.querySelector('iframe');
    // if (iframe) {
    //   iframe.addEventListener('load', () => {
    
    //   });
    // }

    const video = document.getElementById('video-background') as HTMLVideoElement;
    if (video) {
      video.muted = true; // force mute from code (some browsers need this)
      video.addEventListener('loadeddata', () => {
        video.classList.add('video-loaded');
      });
    }


  }

  // getVideoUrl(): string {
  //   return `https://www.youtube.com/embed/${this.videoId}?autoplay=1&mute=1&loop=1&playlist=${this.videoId}&controls=0&showinfo=0&modestbranding=1&rel=0`;
  // }
}
